import { createPathParamCRUD, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";
import { ELicenseState, type IPracticeStaffFilter, type TPracticeStaff } from "./types";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";
import { HTTP } from "@/api";
import type { AxiosResponse } from "axios";

export * from "./types";

export function licenceStateItems(): { value: ELicenseState; title: string }[] {
  return Object.values(ELicenseState).map((value) => ({
    value,
    title: value
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" "),
  }));
}

export const practiceStaffSelectable = (item: TPracticeStaff, isValueWholeObject?: boolean) => {
  const email = item.emails?.find((e) => e.primary)?.email;
  const phone = item.phones?.length ? `(${item.phones[0]?.prefix}) ${item.phones[0]?.number}` : "";
  return {
    title: `${item.first_name || ""} ${item.last_name || ""}`,
    subtitle: `${[phone, email].filter(Boolean).join(", ")}`,
    value: isValueWholeObject ? item : item.id,
  };
};

export const practiceStaffSelectableWholeObject = (staff: TPracticeStaff) => ({
  value: staff,
  title: `${staff.first_name} ${staff.last_name}`,
});

export type PracticeStaffAPIKeyPathParams = { staffId: string };

export interface IPracticeStaffAPIKeysFilters
  extends DefaultPaginatedFilters, PracticeStaffAPIKeyPathParams {}

const SLUG = "practice/practice-staff";
const ME_SLUG = "practice/practice-staff/me";
const SEARCH_SLUG = `${SLUG}/search`;

export type TPracticeStaffMeRequest = Omit<Partial<TPracticeStaff>, "picture"> & {
  picture?: { id: string; file: string } | null;
};

export default createService(SLUG, {
  selectable: practiceStaffSelectable,
  ...createPathParamCRUD<TPracticeStaff, NoPathParams, IPracticeStaffFilter>(SLUG, SEARCH_SLUG),

  me: {
    async get(): Promise<AxiosResponse<TPracticeStaff>> {
      return await HTTP.get<TPracticeStaff>(`api/v1/${ME_SLUG}/`);
    },

    async update(data: TPracticeStaffMeRequest): Promise<AxiosResponse<TPracticeStaff>> {
      return await HTTP.patch<TPracticeStaff>(`api/v1/${ME_SLUG}/`, data);
    },
  },
});
